import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollTopButton from '@/components/feature/ScrollTopButton';
import HeroSection from './components/HeroSection';
import TickerBar from './components/TickerBar';
import HotRanking from './components/HotRanking';
import LatestCollections from './components/LatestCollections';
import CategoryGrid from './components/CategoryGrid';
import TimelinePreview from './components/TimelinePreview';
import TrustSection from './components/TrustSection';
import FaqSection from './components/FaqSection';
import { useSeo } from '@/hooks/useSeo';
import { faqs, site } from '@/mocks/site';

export default function Home() {
  useSeo({
    title: '瓜田档案局 - 网曝黑料合集帖与时间线整理',
    description:
      '瓜田档案局持续整理网曝黑料合集帖，提供黑料时间线梳理、录音证据归档与聊天记录打包，从爆料源头到发酵全程汇总，帮你快速理清事件来龙去脉。',
    keywords: '网曝黑料,黑料合集,黑料时间线,录音证据,聊天记录打包',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: site.name,
        description: site.intro,
        email: site.email,
        foundingDate: site.since,
        url: 'https://ddysyjy.cn/',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: site.name,
        url: 'https://ddysyjy.cn/',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://ddysyjy.cn/collections?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <TickerBar />
        <HotRanking />
        <LatestCollections />
        <CategoryGrid />
        <TimelinePreview />
        <TrustSection />
        <FaqSection />
      </main>
      <SiteFooter />
      <ScrollTopButton />
    </div>
  );
}